import { all } from "redux-saga/effects";
import sagaUtils from "../sagaUtils";
import zoneRequestFunctions from "./zoneRequestFunctions";

export default function* rootSaga() {
  yield all(sagaUtils.extractRequestFunctions(zoneRequestFunctions));
}
